const TEMPLATE_STORAGE_KEY = 'boppps_templates_v1';

const safeParse = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn('[TemplateStorage] Failed to parse templates', error);
    return fallback;
  }
};

const normalizeTemplates = (templates) =>
  (Array.isArray(templates) ? templates : []).filter((template) => template && typeof template === 'object');

const sortTemplates = (templates) =>
  [...templates].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

const generateTemplateId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `template_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

export const loadTemplates = () => {
  if (typeof window === 'undefined') return [];
  const stored = safeParse(window.localStorage.getItem(TEMPLATE_STORAGE_KEY), []);
  return sortTemplates(normalizeTemplates(stored));
};

export const saveTemplate = ({ id, name, description, templateJson }) => {
  if (typeof window === 'undefined') return null;
  const now = new Date().toISOString();
  const templates = loadTemplates();
  const trimmedName = name.trim();

  const existingIndex = templates.findIndex((template) => template.id === id);
  const existing = existingIndex >= 0 ? templates[existingIndex] : null;

  const nextTemplate = {
    id: existing?.id || generateTemplateId(),
    name: trimmedName,
    description: description?.trim() || '',
    createdAt: existing?.createdAt || now,
    updatedAt: now,
    templateJson
  };

  const nextTemplates = existingIndex >= 0
    ? templates.map((template, index) => (index === existingIndex ? nextTemplate : template))
    : [...templates, nextTemplate];

  window.localStorage.setItem(TEMPLATE_STORAGE_KEY, JSON.stringify(nextTemplates));
  return nextTemplate;
};

export const deleteTemplate = (id) => {
  if (typeof window === 'undefined') return [];
  const templates = loadTemplates();
  const nextTemplates = templates.filter((template) => template.id !== id);
  window.localStorage.setItem(TEMPLATE_STORAGE_KEY, JSON.stringify(nextTemplates));
  return nextTemplates;
};

export const findTemplateByName = (templates, name) => {
  const trimmed = name.trim().toLowerCase();
  return (templates || []).find((template) => template?.name?.trim().toLowerCase() === trimmed) || null;
};

export const TEMPLATE_STORAGE_KEY_NAME = TEMPLATE_STORAGE_KEY;
